export default class ParallaxController {
    constructor(autoinit = true) {
        if (autoinit) {
            this.init();

            this.scrollScenes = [];
        }
    }

    init() {
        if (document.querySelectorAll('.parallaxSceneScroll').length) {
            this.runScrollParallax();
        }
    }

    runScrollParallax() {
        import(/* webpackChunkName: "modules/parallaxScroll" */ 'rellax').then(module => {
            const Parallax = module.default;

            document.querySelectorAll('.parallaxSceneScroll').forEach(scene => {
                this.scrollScenes.push(new Parallax(scene, {
                    center: true
                }));
            });
        });
    }
}